import React, {useState} from 'react'
import {Link} from 'react-router-dom'
// mui components
import { makeStyles, Typography, Modal, AppBar, Toolbar, IconButton } from '@material-ui/core'
import MenuIcon from '@material-ui/icons/Menu';
// reused components
import PriceTable from "components/Table/PriceTable.js"
import ContactForm from "components/Contact/ContactForm.js"
// media assets
import seta from "assets/img/seta.png";
import syringe from "assets/videos/syringe720.mov";
import bgImage from "assets/img/sidebar-1.jpg";

const useStyles = makeStyles(theme => ({
  root: {
    background: 'transparent',
    fontSize: 18,
    height: '100vh',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    objectFit: 'contain',
    [theme.breakpoints.down("xs")]: {
      display: "none",
    },
  },
  bgVideo: {
    height: '100vh',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    boxShadow: 'inset 0 0 0 1000px rgba(0, 0, 0, 0.2)',
    objectFit: 'fill',
  },
  loginLink:{
    position: 'absolute',
    top: '2%',
    right: '2%',
    color: 'rgb(150, 150, 150)',
    background: 'rgb(15, 25, 150)',
    borderRadius: 3,
    textDecoration: 'none',
    fontWeight: 600,
    fontSize: '13px',
    padding: 5,
    zIndex: 1000,
    boxShadow: '2px 2px 4px 1px rgba(30, 30, 30, 0.5)',
    '&:hover':{
      fontWeight: 900,
      fontSize: '14px',
      color: 'rgb(190, 190, 190)',
    },
  },
  title:{
    fontSize: 50,
    fontFamily: 'Verdana',
    position: 'fixed',
    top: 50,
    color: 'rgb(132, 128, 147)',
    margin: '0 auto',
    maxWidth: '99%',
    background: 'rgb(15, 25, 150)',
    padding: '0 10px 0 10px',
    whiteSpace: 'nowrap',
    [theme.breakpoints.down("xs")]: {
      display: 'flex',
      justifyContent: 'space-around',
      zIndex: '3',
      width: '101vw',
      textAlign: 'center',
      top: 0,
      right: 0,
      left: 0,
      minHeight: '50px',
      lineHeight: '40px',
      padding: '5px 0 5px 0',
      boxShadow: '2px 0px 5px 2px rgba(30, 30, 30, 0.6)'
    },
  },
  titleTextMobile:{
    fontSize: '5.3vw',
  },
  clique:{
    position: 'fixed',
    top: '33%',
    left: '40%',
    fontSize: 48,
    fontWeight: 300,
  },
  seta:{
    width: 30,
    height: 30,
    transform: 'scaleY(-1)'
  },
  animated:{
    '&:before': {
      content:'""',
      position: 'absolute',
      width: '400px',
      height: '400px',
      background: `linear-gradient(rgb(20, 30, 105), rgb(25, 50, 125), rgb(35, 70, 140),
      rgb(50, 75, 150), rgb(25, 50, 125), rgb(55, 65, 175), rgb(25, 50, 125))`,
      left: '50%',
      top: '8px',
      transform: 'translateX(-50%)',
      borderRadius: '40%',
      animation: '$fill 5s ease-in-out 0s 1 normal forwards',
      zIndex: '-1',
    },
  },
  menu: {
    position: 'fixed',
    top: '60%',
    left: '75%',
    width: '140px',
    height: '140px',
    border: 'none',
    fontWeight: '100',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
},
  '@keyframes fill': {
    '0%': {
      top: '155px',
      transform: 'translateX(-50%) rotate(0deg)',
    },
    '100%': {
      top: '8px',
      transform: 'translateX(-50%) rotate(540deg)',
    },
  },
  invisible:{
    display: 'none'
  },
  menuItem: {
    background: 'transparent',
    border: 'none',
    margin: '5px auto',
    color: 'transparent',
    '&:hover':{
      fontWeight: 900,
      fontSize: '17px',
      cursor: 'pointer',
      color: 'rgb(200, 200, 210)',
    },
  },
  menuVisible:{
    color: 'rgb(200, 200, 210)',
  },
  modal:{
    position: 'relative',
    top: '25%',
    margin: '0 auto',
    width: '600px',
    maxWidth: '80%',
    backgroundColor: 'rgb(251, 248, 252)',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2),
    [theme.breakpoints.down("xs")]: {
      maxHeight: '80vh',
      top: '70px',
      overflow: 'scroll',

    },
  },
  modalBody:{
    textAlign: 'justify',
  },
  mobile:{
    background: 'rgb(20, 20, 20)',
    [theme.breakpoints.up("sm")]: {
      display: "none",
    },
  },
  bgImage: {
    width: '100vw',
    height: '100vh',
    objectFit: "cover",
    filter: 'brightness(25%)',
    opacity: '0.9',
    transformOrigin: 'top right',
  },
  toque:{
    fontSize: '26px',
    backgroundColor: 'rgba(0, 0, 0, 0.08)',
    padding: 10,
    color: 'lightpink',
    background: 'white',
    position: 'fixed',
    top: '60%',
    zIndex: 9,
    textAlign: 'center',
    width: '100%'

  },
  mobileAnimation:{
    animation: '$turn 600ms ease-in-out 0s 1 normal forwards',
  },
  '@keyframes turn': {
    '0%': {
      filter: 'brightness(24%)',
    },
    '100%': {
      filter: 'brightness(15%)',
      transform: 'rotate(15deg)',
    },
  },
  mobileMenu:{
    position: 'absolute',
    right: 0,
    top: 0,
    width: '100vh',
    height: '300px',
    background: 'linear-gradient(to left, rgb(15, 25, 150), rgb(15, 20, 70), rgba(20, 20, 20, 0.5))',
    transform: 'rotate(-90deg)',
    transformOrigin: 'top right',
  },
  mobileItem:{
    background: 'transparent',
    padding: 10,
    color: 'lightgrey',
    border: '1px solid white',
    borderRadius: 5,
    boxShadow: '2px 0px 5px 2px rgba(30, 30, 30, 0.6)',
    transform: 'rotate(75deg) translateX(50px) translateY(-40px)',
  },
  menuAnimation:{
    animation: '$menu 600ms ease-in-out 0s 1 normal forwards',
  },
  '@keyframes menu': {
    '0%': {
      filter: 'brightness(20%)',
    },
    '100%': {
      transform: 'rotate(-75deg)',
    },
  },
  blink:{
    animation: '$blink 700ms linear 0s 3 normal forwards',
  },
  '@keyframes blink': {
    '0%': {
      opacity: 1,
    },
    '100%': {
      opacity: 0,
    },
  },
  }))


function Home(){
  const classes = useStyles()
  const [animated, setAnimated] = useState(false)

  const saiba = () => {
    return (
      <div className={classes.modalBody}>
        <p><b>www.avaliacaopreanestesica.com</b> é a forma mais rápida, fácil e completa
        de realizar suas consultas pré-anestésicas digitalmente. Feito por
        anestesista para anestesistas</p>
        <p>Basta ter acesso a internet para desfrutar de diversas funcionalidades:</p>
        <p>- Ficha pré-anestésica completa e de rápido preenchimento</p>
        <p>- Customização de campos pré-preenchidos</p>
        <p>- Termo de Consentimento preenchido automaticamente</p>
        <p>- Previsão Orçamentária personalizada</p>
        <p>- Suas fichas ficam salvas sem ocupar espaço e com segurança no banco de dados do Google</p>
        <p>Tudo isso e muito mais economiza nosso precioso tempo para que a gente
        foque no que realmente importa: <b>O PACIENTE</b></p>
      </div>
    )
  }
  const precos = () => {
    return <PriceTable/>
  }
  const contato = () => {
    return (
      <>
      <p>PREENCHA OS CAMPOS ABAIXO PARA NOS ENVIAR SUA DÚVIDA:</p>
      <ContactForm/>
      </>
  )
  }

  const [openModal, setOpenModal] = useState(false)
  const [modelContent, setModalContent] = useState(saiba)

  function showMenu() {
    setTimeout(function(){setAnimated(true)}, 100);
  }
  const handleClose = () => {
    setOpenModal(false)
  }

  return(
    <>
      <div className={classes.root}>
         <h1 className={classes.title}>AVALIAÇÃO PRÉ-ANESTÉSICA</h1>
         <Link className={classes.loginLink} to="/login">
            <div className={classes.logiBtn}>ENTRAR
            </div>
          </Link>
         <video loop muted webkit-playsinline="true" playsInline className={classes.bgVideo} onClick={(e) => {e.target.play(); showMenu()}} >
            <source src={syringe}>
            </source>
         </video>
         <div className={`${classes.clique} ${animated && classes.invisible}`}>
          <img className={classes.seta} src={seta} alt="seta"/>
            <span className={classes.blink}> ! </span>  clique na seringa <span className={classes.blink}> ! </span>
        </div>
         <div className={`${classes.menu} ${animated && classes.animated}`}>
            <button className={`${classes.menuItem} ${animated && classes.menuVisible}`} onClick={() => {setOpenModal(true); setModalContent(saiba)}}>SAIBA MAIS</button>
            <button className={`${classes.menuItem} ${animated && classes.menuVisible}`} onClick={() => {setOpenModal(true); setModalContent(precos)}}>PREÇOS</button>
            <button className={`${classes.menuItem} ${animated && classes.menuVisible}`} onClick={() => {setOpenModal(true); setModalContent(contato)}}>CONTATO</button>
            <button className={`${classes.menuItem} ${animated && classes.menuVisible}`}>
              <Link className={`${classes.menuItem} ${animated && classes.menuVisible}`} to="/login">ENTRAR</Link>
            </button>
         </div>
         <Modal open={openModal} onClose={handleClose} >
            <div className={classes.modal}>
              {modelContent}
            </div>
         </Modal>
      </div>
      <div className={classes.mobile}>
        <AppBar position="static">
          <Toolbar className={classes.title}>
            <Typography variant="h6" className={classes.titleTextMobile}>
            AVALIAÇÃO PRÉ-ANESTÉSICA
            </Typography>
            <IconButton edge="start" className={classes.menuButton} color="inherit" onClick={() => {setAnimated(p => !p)}}>
              <MenuIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
        <div className={`${classes.toque} ${animated && classes.invisible}`} onClick={() => {setAnimated(true)}}>Toque para começar.</div>
        <img className={`${classes.bgImage} ${animated && classes.mobileAnimation}`} onClick={() => {setAnimated(true)}} src={bgImage} alt="syringe"/>
        <div className={`${classes.mobileMenu} ${animated && classes.menuVisible} ${animated && classes.menuAnimation}`}>
          <button className={classes.mobileItem}>
            <Link className={classes.menuVisible} to="/login">ENTRAR</Link>
          </button>
          <button className={classes.mobileItem} onClick={() => {setOpenModal(true); setModalContent(contato)}}>CONTATO</button>
          <button className={classes.mobileItem} onClick={() => {setOpenModal(true); setModalContent(precos)}}>PREÇOS</button>
          <button className={classes.mobileItem} onClick={() => {setOpenModal(true); setModalContent(saiba)}}>SAIBA MAIS</button>
        </div>
      </div>
    </>
  )
}
export default Home
